// import logo from './logo.svg';
import './App.css';
import React from 'react';
import {Routes,Route,Link} from 'react-router-dom';
import Home from './Home';
import About from './About';
import Contact from './Contact';
import HTML from './Programming/HTML/Document';


class App extends React.Component {
 render(){
  return (
    <div className="App">
      <Link to="/">Home</Link>
      <Link to="/about">About</Link>
      <Link to="/contact">Contact</Link>
      <Link to="/introduction">introduction</Link>
      <hr></hr>
      
    <Routes>
      <Route exact path="/" element={<Home/>} />
      <Route  path="/about" element={<About/>} />
      <Route  path="/introduction" element={<HTML/>} />
      <Route  path="/contact" element={<Contact/>} />
    </Routes> 
  </div>
);

 }
}
export default App;